import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { replaceHashValues } from "utils/replaceHashValues";

import Button from "common-components/Buttons";
import Header from "common-components/Header";

const DownloadPending = ({
  pageContent,
  renderCategoryList,
  dateOfRequest,
  showConfirmationModal,
  downloadAvailabilityDate,
  notificationMethod,
  lastExtensionTaken,
  dateRangeLabel,
  ...props
}) => (
  <Fragment>
    <Header style={{ maxWidth: "230px" }}>{pageContent.section_title}</Header>
    <Div>
      <p>
        {convertStringToElements(
          replaceHashValues(pageContent.section_description, {
            requestDate: dateOfRequest,
            dateRangeSelected: dateRangeLabel 
          })
        )}
      </p>
      {renderCategoryList()}
      <p data-qm-encrypt="true">
        {convertStringToElements(
          replaceHashValues(pageContent.Category[0].category_description, {
            downloadAvailabilityDate,
            notificationMethod: notificationMethod,
            lastExtensionTaken
          })
        )}
      </p>
    </Div>

    <Button onClick={showConfirmationModal} background={pageContent.buttons[0].type}>
      {pageContent.buttons[0].text}
    </Button>
  </Fragment>
);

DownloadPending.propTypes = {
  pageContent: PropTypes.object.isRequired,
  renderCategoryList: PropTypes.func.isRequired,
  dateOfRequest: PropTypes.string.isRequired,
  dateRangeLabel: PropTypes.string.isRequired,
  showConfirmationModal: PropTypes.func.isRequired,
  downloadAvailabilityDate: PropTypes.string.isRequired,
  notificationMethod: PropTypes.string.isRequired
};

export default DownloadPending;

const Div = styled.div`
  margin-bottom: 55px;
  p {
    margin: 15px 0;
  }
`;
